<template>
  <div class="index">
    <nav-header :navs="1" />
    <div class="content">
      <div class="swiper-centers">
<!--        <swiper class="swiper-container" :options="swiperOption">-->
<!--          <swiper-slide v-for="(item, index) in slideList" :key="index">-->
<!--            <img :src="'http://www.anjpower.com/'+item.image" alt="" width="100%" height="auto" />-->
<!--          </swiper-slide>-->
<!--          <div class="swiper-pagination" slot="pagination"></div>-->
<!--          <div class="swiper-button-prev" slot="button-prev"></div>-->
<!--          <div class="swiper-button-next" slot="button-next"></div>-->
<!--        </swiper>-->
        <video
          src="../assets/image/company-video.mp4"
          controls
          autoplay
          loop
          muted
          poster="../assets/image/1-1.jpg">
        </video>
      </div>
      <div class="product-center">
        <div class="index-public">
          <div class="title">产品中心</div>
          <div class="public-a" @click="goPages('/product/index')">查看所有产品</div>
        </div>
        <div class="sec_fadeInUp" v-on:mouseleave="handleave(1)">
          <el-row>
            <el-col :xs="{span:24}" :sm="{span:18}" :lg="{span:18}">
              <el-row>
                <el-col :xs="{span:24}" :sm="{span:8}" :lg="{span:8}">
                  <div class="pro_box" v-on:mouseover="cphover('33')">
                    <div class="pro_con_img">
                      <img src="../assets/img/srbczz_1.png" alt="智能集成电力电容补偿装置">
                      <p class="cp_sta_title">智能集成电力电容补偿装置</p>
                    </div>
                    <div class="pro_con_txt" v-show="cpthumbshow" :class="{ secon: cpnum == '33'}">
                      <div class="public_btn" @click="goPages('/product/type_list/33')">详情</div>
                    </div>
                  </div>
                </el-col>
                <el-col  :xs="{span:24}" :sm="{span:8}" :lg="{span:8}">
                  <div class="pro_box" v-on:mouseover="cphover('35')">
                    <div class="pro_con_img">
                      <img src="../assets/img/jcdldr_1.png" alt="智能抑谐式集成电力电容补偿装置">
                      <p class="cp_sta_title">智能抑谐式集成电力电容补偿装置</p>
                    </div>
                    <div class="pro_con_txt" v-show="cpthumbshow" :class="{ secon: cpnum == '35'}">
                      <div class="public_btn" @click="goPages('/product/type_list/35')">详情<i></i></div>
                    </div>
                  </div>
                </el-col>
                <el-col  :xs="{span:24}" :sm="{span:8}" :lg="{span:8}">
                  <div class="pro_box"  v-on:mouseover="cphover('39')">
                    <div class="pro_con_img">
                      <img src="../assets/img/zhckzz_1.png" alt="综合测控显示装置"/>
                      <p class="cp_sta_title">综合测控显示装置</p>

                    </div>
                    <div class="pro_con_txt" v-show="cpthumbshow" :class="{ secon: cpnum == '39'}">
<!--                      <h3>综合测控显示装置</h3>-->
                      <div class="public_btn" @click="goPages('/product/type_list/33')">详情<i></i></div>
                    </div>
                  </div>
                </el-col>
                <el-col  :xs="{span:24}" :sm="{span:8}" :lg="{span:8}">
                  <div class="pro_box" v-on:mouseover="cphover('41')">
                    <div class="pro_con_img">
                      <img src="../assets/img/dnzlzz_1.png" alt="电能质量治理装置">
                      <p class="cp_sta_title">电能质量治理装置</p>
                    </div>
                    <div class="pro_con_txt" v-show="cpthumbshow" :class="{ secon: cpnum == '41'}">
                      <div class="public_btn" @click="goPages('/product/type_list/41')">详情<i></i></div>
                    </div>
                  </div>
                </el-col>
                <el-col  :xs="{span:24}" :sm="{span:8}" :lg="{span:8}">
                  <div class="pro_box" v-on:mouseover="cphover('43')">
                    <div class="pro_con_img">
                      <img src="../assets/img/ctswugcqi_1.png" alt="传统式无功补偿器件">
                      <p class="cp_sta_title">传统式无功补偿器件</p>
                    </div>
                    <div class="pro_con_txt" v-show="cpthumbshow" :class="{ secon: cpnum == '43'}">
<!--                      <h3>传统式无功补偿器件</h3>-->
                      <div class="public_btn" @click="goPages('/product/type_list/43')">详情<i></i></div>
                    </div>
                  </div>
                </el-col>
                <el-col  :xs="{span:24}" :sm="{span:8}" :lg="{span:8}">
                  <div class="pro_box" v-on:mouseover="cphover('49')">
                    <div class="pro_con_img">
                      <img src="../assets/img/zndlyb.png" alt="智能电力仪表">
                      <p class="cp_sta_title">智能电力仪表</p>
                    </div>
                    <div class="pro_con_txt" v-show="cpthumbshow" :class="{ secon: cpnum == '49'}">
                      <div class="public_btn" @click="goPages('/product/type_list/49')">详情<i></i></div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col  :xs="{span:24}" :sm="{span:6}" :lg="{span:6}">
              <div class="pro_box" style="height: 510px;" v-on:mouseover="cphover('122')">
                <div class="pro_con_img" style="height: 100%;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;">
                  <img src="../assets/img/new_wlwcp.png" alt="物联网产品">
                  <p class="cp_sta_title" style="bottom: 20%">物联网产品</p>
                </div>
                <div class="pro_con_txt" v-show="cpthumbshow" :class="{ secon: cpnum == '122'}">
<!--                  <h3>物联网产品</h3>-->
                  <div class="public_btn" @click="goPages('/product/type_list/122')">详情<i></i></div>
                </div>
              </div>
            </el-col>

          </el-row>
        </div>

      </div>
      <div class="i-plan">
        <div class="index-public">
          <div class="title">解决方案</div>
          <div class="public-a" @click="goPages('/scheme/index')">查看所有解决方案</div>
        </div>
        <div class="index-case-list-box">
          <div class="index-case-inner">
            <div class="left-slide-box">
              <swiper ref="swiperLeft" :options="left_options">
                <swiper-slide>
                  <div class="left-slide-inner" @click="goPages('/scheme/intel_industry')">
                    <div class="icon icon3"></div>
                    <div class="font">智慧工业</div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="left-slide-inner" @click="goPages('/scheme/intel_city')">
                    <div class="icon icon1"></div>
                    <div class="font">智慧城市</div>
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="left-slide-inner" @click="goPages('/scheme/intel_agriculture')">
                    <div class="icon icon2"></div>
                    <div class="font">智慧养殖业</div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="right-slide-box">
              <swiper ref="swiperThumbs" :options="right_options">
                <swiper-slide>
                  <div class="right-slide-inner" @click.stop.prevent="goPages('/scheme/intel_agriculture')">
                    <img src="../assets/img/cs_3.png">
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="right-slide-inner" @click.stop.prevent="goPages('/scheme/intel_city')">
                    <img src="../assets/img/yz_fw.png">
                  </div>
                </swiper-slide>
                <swiper-slide>
                  <div class="right-slide-inner" @click.stop.prevent="goPages('/scheme/intel_industry')">
                    <img src="../assets/img/gy_2.png">
                  </div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
      <div class="i-intro">
        <div class="index-public">
          <div class="title">关于我们</div>
          <div class="public-a" @click="goPages('company/index')">查看更多</div>
        </div>
        <div class="w980">
          <div class="video"><img src="../assets/img/anj_new_company_img.jpg"></div>
          <div class="detail">
            <h2>台州安耐杰电力设备有限公司</h2>
            <p style="text-indent: 2rem;font-size: 16px;letter-spacing: 1px;line-height: 25px;">
              <span>台州安耐杰电⼒设备有限公司成⽴于2011年，是⼀家致⼒于⽆功补偿、电能质量、智慧物联领域的研发、⽣产和销售的国家⾼新技术企业，
                主要产品有：智能电容器、智能抑谐式电容器、电⼒电容器、电抗器、复合开关、动态投切开关等⽆功补偿产品；低电压调节、谐波治理、动静态混
                合补偿、⾼压并联⾃动补偿等成套补偿装置；静⽌⽆功发⽣器（SVG）、有源电⼒滤波器（APF）、三相不平衡矫正（SPC）等电能质量产品；智能嵌
                ⼊式、导轨式电⼒仪表、智慧电⼒采集终端、物联型传感器、综合能源管理平台等智慧物联产品。</span>
            </p>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="i-list">
        <div class="w980">
          <div class="i-news">
            <div class="index-public">
              <div class="title">新闻中心</div>
              <div class="public-a" @click="goPages('/news/index')">查看所有新闻</div>
            </div>
            <div class="news-single">
              <a @click.stop.prevent="goPages('/news/detail/'+firstNews.id)">
                <img v-if="firstNews.image.indexOf('http') != -1" :src="firstNews.image" width=278px height=193/>
                <img v-else :src="`http://www.jiukaist.com${firstNews.image}`" width=278px height=193 />
                <p class="int">{{firstNews.title}}</p>
              </a>
            </div>
            <div class="list fr">
              <ul class="company-news"
                  :title="item.title"
                  @click.stop.prevent="goPages('/news/detail/'+item.id)"
                  v-for="(item,index) in newsList"
                  :index="index"
                  :key="index">
                <li v-if="index>0 && index<5" >
                  <span class="fl">{{'0'+index}}</span>
                  <div class="fr">
                    <p class="layui-elip new-titless">{{item.title}}</p>
                    <p>{{item.createtime}}</p>
                  </div>
                </li>
              </ul>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
    <nav-footer />
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import NavHeader from "@/components/NavHeaders.vue";
import NavFooter from "@/components/NavFooter.vue";
import ApiCon from "../util/Api/index";

export default {
  name: "index",
  data() {
    return {
      options: {
        pagination: {
          el: ".case-swiper-pagination",
        },
        loop: true,
        loopedSlides: 5,
        slidesPerView: 5,
        speed: 1000,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loopAdditionalSlides: 1,
        on: {
          slideChangeTransitionEnd: function () {
            // console.log(this.activeIndex);
          },
        },
      },
      swiperOption: {
        autoplay: true,
        loop: true,
        speed: 4000,
        cubeEffect: {
          shadowOffset: 100,
          shadowScale: 0.6,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
	  //banner轮播图列表
      slideList: [],
      newsList:[],//新闻列表
      firstNews:{},
      left_options:{
        notNextTick: true,
        direction:'vertical',
        setWrapperSize: true,
        freeMode:true,//true则是自由模式，不会自动贴合滑动位置
        loop:true,//循环
        loopedSlides: 3,
        autoplay: {
          delay:3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loopAdditionalSlides: 1,
        spaceBetween:0,//slide之间的距离，px
        slidesPerView:3 ,//slide可见数量
        mousewheelControl : true,//鼠标滚轮控制
        grabCursor:true,//鼠标变为抓手
        // observer: true,
      },
      right_options:{
        loop: true,
        loopedSlides: 3,
        slidesPerView: 'auto',
        autoplay: false,
        loopAdditionalSlides: 1,
        touchRatio: 0.2,
        centeredSlides: true
      },
      cpnum:'',
      cpthumbnum:'',
      cpthumbshow:false,
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    NavHeader,
    NavFooter,
  },
  // updated() {
  //   this.$nextTick(() => {
  //     const swiperLeft = this.$refs.swiperLeft.$swiper;
  //     const swiperThumbs = this.$refs.swiperThumbs.$swiper;
  //     swiperLeft.controller.control = swiperThumbs;
  //
  //   });
  // },
  mounted() {
    this.ApiCon = new ApiCon(this.$store);
    this.ApiConUrl = this.ApiCon.getApiUrl();
    this.getnewsList();
    localStorage.clear();

  },
  created() {
    this.ApiCon = new ApiCon(this.$store);
    //this.$layer.msg('你好')
    this.ApiConUrl = this.ApiCon.getApiUrl();
    this.baseUrl = this.ApiConUrl;
    let self = this;
    // self.getBannerLists();

  },
  methods: {
    goProPage(val){
      let self = this;
      self.$router.push("/product/type_list/" + val);
      localStorage.clear();
    },
    goPages(val) {

      this.$router.push(val);
    },
    getBannerLists() {
      let self = this;
      this.$api.mall
        .getBannerList({
          limit: 14,
          page: 1,
        })
        .then((ress) => {
          let res = ress.data.data.data;
          self.slideList = res;
        });
    },
    getnewsList() {
      let self = this;
      this.$api.mall
          .getNews({
            limit: 10,
            page: 1,
            type: '',
          })
          .then((ress) => {
            let res = ress.data.data.data;
            if(res.length>0){
              res.forEach((item,index) => {

                if(index == 0){
                  self.firstNews = item
                }
                self.newsList.push(item)
              })
            }
            self.newsList = res;
            self.firstNews = res[0]
          });
    },
    handleave(val) {
      let self = this;
      if (self.activea == 1) {
        self.cpthumbnum = "";
        self.nava = "";
        self.showsNav = false;
      } else {
        self.cpthumbnum=''
        self.nava = self.activenava;
      }
      self.cpnum = self.activea;
    },
    cphover(val) {
      let self = this;
      // console.log(val)
      self.cpnum = val;
      self.cpthumbnum = val;
      self.cpthumbshow = true;
    },

  },
};
</script>
<style lang='scss' scoped>
@import "src/assets/scss/newindex";
.swiper-centers {
  width: 100%;   /* 父容器宽度 */
  height: 750px;  /* 父容器高度 */
  overflow: hidden; /* 超出部分隐藏 */
  position: relative;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover; /* 铺满并保持比例 */
    display: block;    /* 去掉默认空隙 */
  }
}
@media screen and(max-width:768px){
  .swiper-centers {
    width: 100%;   /* 父容器宽度 */
    height: 250px!important;  /* 父容器高度 */
  }
}
</style>
